import {
  FETCH_MANUFACTURERS_LIST,
  RESET_MANUFACTURERS_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const manufacturersListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MANUFACTURERS_LIST:
      return { list: action.payload };
    case RESET_MANUFACTURERS_LIST:
      return initialState;
    default:
      return state;
  }
};

export default manufacturersListReducer;
